"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.passwordRecoveryCopy = void 0;
const onboardingHeroCopy_1 = require("./onboardingHeroCopy");
exports.passwordRecoveryCopy = {
    header: 'Reset Your Password',
    input1: 'Email Address',
    cta: 'Send Reset Link',
    prompt: 'Enter your email and we will send a link to change your password',
    heroHeader: onboardingHeroCopy_1.onboardingHeroCopy.header,
    heroSubHeader: onboardingHeroCopy_1.onboardingHeroCopy.subHeader,
    confirmation: "Request received! If you have an account with us, you'll receive an email to reset your password.",
    linkPrompt: 'Log in to your account',
    linkHref: '/login',
    errorTitle: 'Reset Password Error'
};
